



































import { Component, PropSync, Emit } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import InputDatePicker from '@/components/molecules/InputDatePicker/InputDatePicker.vue'
import dayjs from '@/node_modules/dayjs'

export interface UsageStatisticsSearchConditionItem {
  targetDate: {
    input: string
    errorMessage: string
  }
}

export const defaultUsageStatisticsSearchConditionItem = (): UsageStatisticsSearchConditionItem => ({
  targetDate: {
    input: dayjs().format('YYYYMMDD'),
    errorMessage: ''
  }
})

@Component({
  components: { InputDatePicker }
})
export default class UsageStatisticsSearchCondition extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: UsageStatisticsSearchConditionItem[]

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  @Emit('reading')
  onClickReading(): void {}

  @Emit('prev')
  onClickPrev(): void {}

  @Emit('next')
  onClickNext(): void {}
}
